export default {
  message: {
    loading: "加载中",
    submit: "提交",
    invoiceAndPost: "发票和邮寄信息",
    productAndService: "产品和服务",
    payAliAccount: "支付账户",
    success: "操作成功",
    year: "年",
    day: "日",
    person: "人",
    errorTip: "错误提示",
    term: "《通用隐私政策》",
    salesTerm: "《销售服务合同》",
    supplementTerm: "《软件服务合同》",
    serviceContract: "《服务合同》",
    saleTip: "请联系销售下单",
    auth: {
      name: "去认证",
      none: "您还未进行企业主体认证，为保障您的合法权，请",
      noneAli: "您还未进行企业主体认证",
      toVertify: "立即认证",
      pass: "企业认证已通过",
      pending: "企业认证审核中，您的认证信息正在审核中，请稍后查看",
      refuse: "企业认证不通过",
      confirm: "请确认",
      noVerify: "您还未完成企业认证，请先提交",
      verifyToPC: "您还未完成企业认证，请用PC提交企业认证",
      certification: "企业认证",
      tarilPass: "您的企业主体认证初审通过，请进行",
      nextVertify: "下一步认证"
    },
    activate: {
      tips: "您还有未激活订单",
      action: "去激活"
    },
    execute: {
      tips: "您还有未执行合同",
      action: "去执行"
    },
    complete: {
      tips: "您还有待支付订单",
      action: "去完成"
    },
    back: "返回上一步",
    backOrder: "返回订单列表"
  },
  component: {
    upload: "点击上传"
  },
  sideBar: {
    site: "OKKI 商城",
    home: "首页",
    buy: "我要购买",
    order: "我的订单",
    voucher: "我的优惠券",
    invoice: "我的发票",
    worktime: "工时中心"
  },
  home: {
    title: "我的产品",
    expiration: "当前订单有效期",
    latest_expiration: "最晚到期时间",
    empty: "您当前还未购买任何产品",
    buy: "立即购买",
    detail: "查看明细",
  },
  store: {
    append: "追加",
    renew: "续约",
    upgrade: "升级",
    buy: "购买",
    to: "至",
    choice: "请选择",
    selected: "已选择",
    product: "项产品",
    total: "合计",
    free: "免费升级",
    settle: "去结算",
    error: ["请先选择产品", "无法购买，请刷新页面", "请输入预存广告费"],
    recommend: {
      code: "推荐码",
      tips: "请输入推荐码",
      submit: "验证",
      message: {
        error: ["推荐码为空", "请先验证邀请码"],
        success: "推荐码验证成功"
      }
    },
    productAndService: "项产品和服务",
    agree: "同意",
    and: "及",
    submit: "提交订单",
    tip: "提示",
    agreeText: "并愿意接收来自xiaoman.cn或okki.com的服务邮件",
    warnTips: [
      "您将要",
      "的产品与当前产品在功能、",
      "追加账号价格",
      "方面存在较大差异，",
      "新的产品版本将不再提供订单、报价单、审批等产品功能，",
      "同时与之相关的数据也将不再保留。",
      "请您务必了解相关内容，如需了解更多，请访问",
      "产品功能介绍"
    ],
    warnAgree: "已了解，去结算",
    googleAnvance: "（到账广告费，不含税）",
    storeCloseTip: "OKKI商城升级维护中，预计完成时间2021年1月4号。",
    noProductTip:"您当前没有可新签、续约、追加、升级的产品"
  },
  order: {
    unlimited: "不限",
    history: "历史订单",
    unpaid: "未完成订单",
    number: "订单号",
    aliOrderNo: "阿里订单号",
    aliOrderLine: "阿里订单行",
    product: "产品和服务",
    paidTime: "付款时间",
    amount: ["实付金额", "应付金额"],
    paidAmount: "已支付",
    discountAmount: "优惠金额",
    totalAmount: "总计金额",
    pending: "待支付金额",
    paid: "已支付订单",
    complete: "已完成订单",
    auth: "企业认证后可激活订单",
    post: "申请发票后可激活订单",
    goPost: "去申请",
    payWay: "支付方式",
    waitPaySync: "订单同步国际站后台异常，请等待处理",
    mobile: "移动支付",
    zhifubao: "支付宝支付",
    alibaba: "阿里巴巴",
    alibabaShop: "国际站店铺",
    union: "转账付款",
    unionDollar: "美元付款",
    dollarTips: "请注意：转账手续费由您承担",
    alibabaLogin: "登录",
    alibabaPay: "阿里巴巴卖家后台支付",
    mobileTitle: "本次支付金额",
    mobileTotal: "全额支付",
    refreshCode: "刷新二维码",
    mobileTips: "金额1000-39400范围",
    company: "公司名",
    summary: "简要",
    cancel: "取消订单",
    activate: "激活订单",
    subTotal: "小计",
    originAmount: "原价",
    share: "点击右上角，转发给客户",
    authError: "您还未提交企业认证，不可激活订单",
    postError: "您还未提交发票申请，不可激活订单",
    activateError: "未知错误！不可激活订单，请联系相关人员",
    activateSuccess: "激活订单成功",
    download: ["下载合同", "下载待付款证明", "下载发票","销售证明"],
    loading: "订单提交",
    signPayComfirm: "签署代付款证明后可激活订单",
    signContract: "签署合同后可激活订单",
    overseaSignPayComfirm: "订单暂不可用，请联系销售经理上传代付款证明",
    overseaSignContract: "订单暂不可用，请联系销售经理上传合同",
    sign: "去签署",
    orderInfoNone: "付款水单信息不完整，请等待系统更新",
    alreadyPaid: "已付",
    transferIn: '历史订单转入',
    refund: '已退款',
  },
  product: {
    name: "产品",
    new: "新签",
    renew: "续约",
    append: "追加",
    upgrade: "升级",
    activate: "激活",
    type: "类型",
    year: "年限",
    upgradeTo: "升级至",
    upgradeRenewTo: "升级和续约至",
    upgradeContract: "升级合同",
    upgradeContractTips: "默认升级所有可升级的订单/合同",
    upgradeRenewContractTips: "续约2年标准方案（10账号，1024GB空间，20万封EDM）",
    oriDate: "原产品时间",
    siteName: "Shops站点",
  },
  service: {
    granted: "已发",
    pendingGrant: "待发",
    account: "账号",
    purchased: "已购",
    used: "已用",
    available: "可用",
    remaining: "剩余",
    to: "至",
    type: "类型",
    space: "空间",
    standard: "标配",
    extra: "额外购买",
    append: "追加",
    per: "份",
    maxAccount: "该方案最大账号数：",
    maxTotalBuy: "当前合计已购买：",
    extraCount: "您还可增购：",
    okkiBaseApi: "追加OKKI-API标准接口：",
    okkiBaseApiCallCount: "追加OKKI-API接口调用次数：",
    okkiBaseApiOption1: "是",
    okkiBaseApiOption2: "否",
    okkiBaseApiYearCallCount: "每份含接口调用次数：300000次/年",
    okkiBaseApiTip: "（不限次数）"
  },
  union: {
    name: "户名",
    account: "账户",
    bank: "开户行",
    remark: "交易备注",
    amount: "汇款金额",
    payInfo: "完成转账后，请提供您的付款账号信息",
    payer: "付款人",
    payerPlaceholder: "请填写完整的开户名",
    payAccount: "付款账号",
    payAccountPlaceholder: "请填写付款账号",
    amountList: "上传水单",
    tips: "您的付款账号信息已提交",
    tipsInfo: "转账付款到账周期一般为1~3个工作日，请耐心等待。如有问题，请联系",
    payerError: "请填写付款人",
    payAccountError: "请填写付款账号",
    amountListError: "请上传水单"
  },
  invoice: {
    tips: [
      "请确认发票信息，一旦开具将无法修改，开票金额不包括优惠/抵扣部分",
      "我司依法开具发票，请您按照税法规定使用发票"
    ],
    notice: "新税率公告",
    name: "发票信息",
    special: "增值税专用发票",
    general: "电子普通发票",
    digitalSpecial: "数电专票",
    digitalGeneral: "数电普票",
    formal: "形式发票",
    type: "发票类型",
    status: "发票状态",
    company: "单位名称",
    taxpayer: "纳税人识别号",
    address: "注册地址",
    tel: "注册电话",
    viewDetail: "查看详情",
    bank: "开户银行",
    bankAccount: "银行账号",
    error: "请完善发票信息",
    letter: "一般纳税人认定通知书",
    download: "下载发票",
    reapply: "重新申请",
    message: {
      company: "请输入单位名称",
      bankAccount: "请输入银行账号",
      bank: "请输入开户银行",
      address: "请输入注册地址",
      tel: "请输入注册电话",
      taxpayer: "请输入纳税人识别号",
      letter: "请上传一般纳税人认定通知书"
    },
    // 发票列表页面字段
    orderNo: "OKKI订单号",
    aliOrderNo: "阿里订单号", 
    product: "产品",
    totalPayment: "合计支付",
    refundAmount: "退款/转出 金额",
    invoiceType: "发票类型",
    invoiceNo: "发票号码",
    invoiceAmount: "开票金额",
    invoiceDate: "开票日期",
    invoiceStatus: "状态",
    operation: "操作",
    transferInAmount: "转入金额",
    supplementAmount: "补充支付",
    billType: "发票属性",
    isOnlineInvoice: "是否线上发票",
    // 发票详情页面新增字段
    myInvoice: "我的发票",
    invoiceDetail: "发票详情",
    otherOrderRedInvoice: "其他订单发票红冲",
    pendingRedInvoiceWarning: "您有待处理的发票冲红，请优先处理",
    historyOrdersInvolved: "本票涉及的历史订单",
    currentInvoiceInfo: "本票信息",
    invoiceTitle: "发票抬头：",
    invoiceTaxNo: "发票税号：",
    selectInvoiceType: "请选择发票类型",
    loading: "正在加载发票信息...",
    confirming: "确认中...",
    redProcessing: "红冲处理中...",
    downloadAddressNotExist: "发票下载地址不存在",
    refundTransferTips: "本票订单涉及退款或转出，开票金额将根据合计金额减去退款或转出金额，开具消耗金额发票；",
    redProcessTips: {
      history: "本票订单涉及历史订单价值转入，申请本票开具前，请先处理历史订单的部分或全额红冲：",
      current: "本票订单涉及退款或转出，且本订单已开蓝票，现需进行部分或全额红冲",
      step1: "未抵扣的蓝票：系统已根据转出金额，对蓝票进行自动红冲。您可点击下载红票；",
      step2: "已抵扣的蓝票：需要您公司财务登录税务局进行确认红字信息表。",
      step21: "请点击\"去电子税务局确认\"或直接访问电子税务局 ({url}) 进行红字信息表确认；",
      step22: "在电子税务局确认完成后，系统将对蓝票进行自动红冲；",
      step23: "红票开具后，您可点击下载红票；",
      guideLink: "红字信息单操作指引",
      guideText: "查看说明："
    }
  },
  post: {
    name: "邮寄信息",
    contact: "收件人",
    code: '邮政快递',
    mobile: "联系电话",
    area: "所在地区",
    address: "详细地址",
    error: "请完善邮寄信息",
    message: {
      contact: "请输入收件人",
      mobile: "请输入联系电话",
      area: "请选择所在地区",
      address: "请输入详细地址"
    }
  },
  voucher: {
    name: "代金券",
    tips: "代金券不设找赎",
    agency: "代理商优惠券",
    discount: "折",
    limit: "使用限制",
    expiration: "有效期至",
    source: "来源",
    denomination: "优惠面额",
    status: "状态"
  },
  mainlandAuth: {
    step1: "法人信息",
    step2: "企业信息",
    step3: "信息审核",
    step4: "完成",
    authVertify1: "您即将打开第三方平台进行验证，请根据页面提示进行操作验证：",
    authVertify2: "若没自动打开，请点击",
    authVertify3: "。若您已完成请点击",
    authVertify4: "去认证",
    refresh: "刷新状态",

    approving: "您的信息正在审核中，请稍后查看",
    approveVertify1: "您的信息",
    approveVertify2: "初审通过",
    approveVertify3: "请点击",
    approveVertify4: "若您已完成提交请点击",
    approveVertify5: "审核不通过",
    approveVertify6: "刷新状态",
    approveVertify7: "重新提交",
    approveVertify9: "完成下一步信息提交",

    description1: "根据2019年4月修订的《",
    description2: "电子签名法",
    description3:
      "》第十三条和第二十条要求，您需要完成企业认证后方能进行有效的电子合同签署",
    description4: "认证服务由",
    description5: "深圳法大大网络科技有限公司",
    description6: "提供",
    description7: "认证和使用过程受 《",
    description8: "法大大使用协议",
    description9: "》、《",
    description10: "法大大隐私政策",
    description11: "》及中国相关法律约束和保障"
  },
  auth: {
    step1: "提交认证信息",
    step2: "信息审核",
    step3: "完成",
    companyName: "认证公司名",
    translatedName: "公司译名",
    creditCode: "统一社会信用代码",
    license: "营业执照(盖公章)",
    licenseTips:
      "营业执照不可涂改，可以备注“用于合同签署”等描述，其他备注均不通过审核。",
    signature: "自动签章",
    read: "我已阅读",
    grant: "《授权使用电子签章委托书》",
    agree: "并同意委托",
    grantContent: [
      "为了委托方在受托方运营的网站（网址为:www.xiaoman.cn）上便利地签署有关电子文件，委托方给予受托方如下代理权限并将在受托方网站进行如下业务：",
      "一、授权受托方提交相关材料向CA机构申请颁发数字证书（以下简称CA证书）；",
      "二、在受托方网站使用自己的CA证书进行电子文件自动签署，签署的文件范围仅限于委托方付款成功的在线订单所涉及的所有应签署的电子文件。",
      "本委托书有效期限为10年；自双方签字（或盖章）之日起生效。"
    ],
    mobile: "绑定手机号",
    code: "人机验证",
    sms: "短信验证码",
    getSms: "获取验证码",
    close: "关闭",
    submit: "提交",
    verify: "验证",
    message: {
      companyName: "请输入公司名",
      translatedName: "请输入公司译名",
      transNameError: "认证公司名或公司译名其中一个必须是中文",
      creditCode: "请输入统一社会信用代码",
      license: "请上传营业执照",
      mobile: "请输入正确的手机号",
      imgCode: "请输入图形验证码",
      mobileCode: "请输入短信验证码",
      errCreditCode: "请输入合法的统一社会信用码"
    },
    pending: "后台审核中...",
    success: "恭喜您！已完成企业认证",
    ci63ee: "请按住滑块，拖动到最右边",
    caf5sf: "验证通过",
    chok49: "网络不给力，请",
    wgmi3n: "点击刷新",
    cybpop: "出错了，点击",
    f1v4y4: "再来一次",
    cgoyus: "加载中...",
    ith53j: "请向右滑动验证",
    pono45: "验证通过",
    y2vznd: "非常抱歉，这出错了..."
  },
  fadada: {
    success: "信息提交成功",
    successTip: "请在PC页面进行下一步操作",
    fail: "信息提交失败",
    failTip1: "请",
    failTip2: "刷新",
    failTip3: "PC页面，再次点击",
    failTip4: "去认证",
    failTip5: "操作"
  },
  appointment: {
    listTitle: "OKKI 新签客户预约实施",
    listDesc1:
      "本预约系统针对新签客户预约实施时间，请根据您的时间进行选择并提交。",
    listDesc2: "实施前10分钟，实施顾问将与您联系。",
    listDesc3: "如有疑问请致电400-0666-517。",
    restCount: "剩余：",
    applyTitle: "预留信息",
    applyTip:
      "您已选择 {time}进行系统实施，请完善相关信息并提交。实施前10分钟，实施顾问将与您联系，请保持电话畅通。",
    company: "公司名",
    contact: "联系人",
    contactPlaceholder: "请填写联系人",
    mobile: "联系电话",
    mobilePlaceholder: "请填写联系电话",
    mobileValidate: "请输入正确的联系电话",
    verifyCode: "验证码",
    sendVerifyCode: "发送验证码",
    wechat: "微信号",
    wechatOptions: "联系手机可添加微信",
    wechatRules: "请输入微信号",
    dingding: "钉钉号",
    dingdingOptions: "联系手机可添加钉钉",
    dingdingRules: "请输入钉钉号",
    sure: "确定",
    cancel: "取消",
    cancelTitle: "是否保留预约",
    cancelTip1: "因实施资源有限，请勿频繁操作取消。",
    cancelTip2: "是否保留{time}进行系统实施的预约？",
    cancelBtn1: "取消预约",
    cancelBtn2: "保留预约",
    cancelSuccess: "取消成功",
    applySuccessTip1:
      "您已预约 {time} 进行系统实施，实施前10分钟，实施顾问将与您联系，请保持电话畅通。",
    applySuccessTip2: "您已完成实施流程，预约培训课程请点击培训预约",
    applyAccount: "本预约系统仅限主账号进行操作，请联系主账号进行预约。",
    applyImplete: "预约培训",
    demandDes: "您正在向小满科技预约在沙盒环境下为用户提供小满SaaS软件的远程实施服务。您理解并知悉，为提高远程实施服务的效率，小满科技需要",
    demandDesB: "采集用户小满SaaS软件中的配置信息（如客户分类分组、客户标签、客户字段设置等，以下简称“配置信息”。配置信息不包括用户录入小满SaaS软件生产环境中的订单信息、买家信息等商业信息）以便提前准备相应的实施方案。",
    demandDesSecondB: "您作为用户小满主账户的管理者点击“下一步”并成功预约远程实施服务时间的，即表明用户授权同意小满科技采集并使用该配置信息；您不同意小满科技采集或使用该配置信息的，请不要在下一步预约远程实施服务的时间。",
    demandComponyName: "公司名",
    demandNext: "下一步",
    appointmentLimit: "累计取消{total_cancel_count}次，冻结{forbid_appointment_hour}小时内不能申请预约。"
  }
};
